import React from "react"
import classNames from "classnames"

import { SFX } from "@/topic/rogue_5/utils/sfx"

import styles from "./index.module.less"

const MainButton: React.FC<{
    className?: string
    style?: React.CSSProperties
    text: string
    textEn: string
    subtitle?: string
    type?: "yellow" | "orange" | "purple" | "blue" | "pink" | "small"
    mark: "wen" | "jie" | null
    icon: string
    onClick?: (e: React.MouseEvent<HTMLDivElement>) => void
}> = ({
    className,
    style,
    text,
    textEn,
    type = "yellow",
    mark = "wen",
    icon,
    subtitle,
    onClick,
}) => {
    return (
        <div
            className={classNames(styles.MainButton, styles[type], className)}
            style={style}
            onClick={(e) => {
                onClick?.(e)
                SFX.play("click")
            }}
        >
            <div className={styles.bg}></div>
            <div className={styles.textCn}>
                <div
                    className={classNames(styles.mark, mark && styles[mark])}
                ></div>
                {text.split("\n").map((line, index) => (
                    <div key={index} className={styles.textLine}>
                        {line}
                    </div>
                ))}
            </div>
            <div className={styles.textEn}>
                {textEn.split("\n").map((line, index) => (
                    <div key={index} className={styles.textLine}>
                        {line}
                    </div>
                ))}
            </div>
            {subtitle && (
                <div className={styles.subtitle}>
                    <span>{subtitle}</span>
                </div>
            )}
            <div className={classNames(styles.icon, styles[icon])}></div>
        </div>
    )
}

export default MainButton
